export const TourFeatures = {
  test: {
    shepherdTracker: true
  }
};